"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STATIC_PATH = exports.BASE_URL = exports.BASE_API_URL = void 0;
var _Utils = require("react-platform-components/dist/Utils");
var BASE_API_URL = (0, _Utils.getBackendConfig)('REACT_BASE_API_URL', process.env.REACT_APP_BASE_API_URL);
exports.BASE_API_URL = BASE_API_URL;
var BASE_URL = (0, _Utils.getBackendConfig)('REACT_BASE_URL', process.env.REACT_APP_BASE_URL);
exports.BASE_URL = BASE_URL;
var STATIC_PATH = process.env.PUBLIC_URL || '';
exports.STATIC_PATH = STATIC_PATH;